import React from "react";
import Hero from "../components/home/hero/Hero";

function Home() {
  return (
    <div>
      <Hero />
    </div>
  );
}

export default Home;
